import React from "react";
import { SITE } from "@/data/site";
import { czk } from "@/lib/price";

function Stat({ label, value, sub, accent, testId }) {
  return (
    <div className="bg-brand-surface border border-brand-border p-5" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.25em] text-brand-muted">{label}</div>
      <div className={`mt-2 font-display font-black text-2xl lg:text-3xl leading-none ${accent ? "text-brand-accent" : "text-white"}`}>
        {value}
      </div>
      {sub && <div className="mt-1.5 text-xs text-brand-muted">{sub}</div>}
    </div>
  );
}

export function AdminStats({ stats }) {
  if (!stats) return null;
  const upsell = stats.revenue_addons + stats.revenue_bundle;
  const share = stats.revenue_total ? Math.round((upsell / stats.revenue_total) * 100) : 0;

  return (
    <div className="space-y-4" data-testid="admin-stats">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat testId="stat-revenue" label="Hodnota poptávek" value={czk(stats.revenue_total)} sub={`${stats.active} aktivních poptávek (bez zrušených) — nejde o uhrazené tržby`} />
        <Stat testId="stat-base" label="Program 4 v 1" value={czk(stats.revenue_base)} sub={`${stats.active} × ${SITE.price}`} />
        <Stat testId="stat-upsell" label="Doplňky a balíčky" value={czk(upsell)} sub={`${share} % z tržeb · ${stats.suv_count} × SUV (+${czk(stats.revenue_surcharge)})`} />
        <Stat
          testId="stat-status"
          label="Stav rezervací"
          value={`${stats.by_status.new} nových`}
          sub={`${stats.by_status.confirmed} potvrzeno · ${stats.by_status.done} hotovo · ${stats.by_status.cancelled} zrušeno`}
        />
      </div>

      <div className="grid lg:grid-cols-2 gap-3">
        <div className="bg-brand-surface border border-brand-border p-5" data-testid="stat-bundles">
          <div className="text-[10px] uppercase tracking-[0.25em] text-brand-muted mb-3">Balíčky</div>
          {stats.bundle_counts.length === 0 && <div className="text-sm text-brand-muted">Zatím žádné.</div>}
          {stats.bundle_counts.map((b) => (
            <div key={b.key} className="flex justify-between text-sm py-1.5 border-b border-brand-border last:border-0">
              <span className="text-white">{b.label} <span className="text-brand-muted">× {b.count}</span></span>
              <span className="text-brand-accent font-semibold">{czk(b.revenue)}</span>
            </div>
          ))}
        </div>
        <div className="bg-brand-surface border border-brand-border p-5" data-testid="stat-addons">
          <div className="text-[10px] uppercase tracking-[0.25em] text-brand-muted mb-3">Jednotlivé doplňky</div>
          {stats.addon_counts.length === 0 && <div className="text-sm text-brand-muted">Zatím žádné.</div>}
          {stats.addon_counts.map((a) => (
            <div key={a.key} className="flex justify-between text-sm py-1.5 border-b border-brand-border last:border-0">
              <span className="text-white">{a.label} <span className="text-brand-muted">× {a.count}</span></span>
              <span className="text-brand-accent font-semibold">{czk(a.revenue)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
